<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-27 22:10:14
 * @LastEditors: wangjx
 * @LastEditTime: 2021-11-09 10:43:13
-->
<template>
  <el-dialog
    :key="formKey"
    v-dialogDrag
    :title="$t('dictInfo.dictViewDetail')"
    :visible.sync="dialogVisible"
    width="75%"
    class="self-dialog-form"
    @close="viewDialogClosed"
  >
    <el-form
      ref="viewFromRef"
      :model="viewFrom"
      class="view_form"
      label-width="100px"
      label-position="left"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="$t('dictInfo.dictView.dictName')"
            prop="dictName"
            style="margin-bottom: 0"
          >
            <span>{{ viewFrom.dictName }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('dictInfo.dictView.dictCode')"
            prop="dictCode"
            label-width="120px"
            style="margin-bottom: 0"
          >
            <span>{{ viewFrom.dictCode }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('dictInfo.dictView.type')"
            prop="dictCode"
            label-width="120px"
            style="margin-bottom: 0"
          >
            <span>{{ viewFrom.dictPermission }}</span>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$t('dictInfo.dictView.dictStatus')"
            prop="dictStatus"
            label-width="120px"
            style="margin-bottom: 0"
          >
            <span>{{ viewFrom.dictStatus }}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item
            :label="$t('dictInfo.dictView.description')"
            prop="description"
            style="margin-bottom: 0"
          >
            <span>{{ viewFrom.description }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      :style="{ width: '100%', height: '8px', background: '#F9F9FB', margin: '12px 0 24px 0' }"
    ></div>
    <div class="view--casecade-title">{{ $t("dictInfo.dictList") }}</div>
    <div class="section--table">
      <div class="section--table--tbody">
        <el-table
          v-loading="loading"
          stripe
          :data="viewFrom.viewDicTableData"
          class="self-table"
          style="width: 100%"
        >
          <el-table-column type="index" :label="$t('common.order')" width="100" />
          <el-table-column
            prop="dictLabel"
            :label="$t('dictInfo.dictItemInfo.dictLabel')"
          ></el-table-column>
          <el-table-column
            prop="dictValue"
            :label="$t('dictInfo.dictItemInfo.dictValue')"
          ></el-table-column>
          <el-table-column prop="sort" :label="$t('dictInfo.dictItemInfo.sort')"></el-table-column>
          <el-table-column
            prop="systemDefault"
            :label="$t('dictInfo.dictItemInfo.systemDefault')"
            :formatter="caseCadeIsSystemFormate"
          ></el-table-column>
          <el-table-column
            prop="description"
            :label="$t('dictInfo.dictItemInfo.description')"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <span slot="footer" class="dialog-footer" style="padding-top: 12px; display: block">
      <el-button
        plain
        @click.prevent="dialogVisible = false"
      >
        {{ $t("common.cancel") }}
      </el-button>
      <!-- <el-button @click.prevent="dialogVisible = false" type="primary">
        {{ $t("public.confirm") }}
      </el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import Dict from "@/api/dict/dict";
export default {
  name: "AddEditDialog",

  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dialogViewData: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      formKey: new Date().getTime(),
      loading: false,
      currentPage: 1,
      dialogVisible: false,
      viewFrom: {},
      isSystemEnum: [
        {
          id: "SYSTEM",
          label: "系统(不可编辑)"
        },
        {
          id: "SYSTEM_BUSINESS",
          label: "系统(可增子项)"
        },
        {
          id: "BUSINESS",
          label: " 业务"
        }
      ],
      dictStatusEnum: [
        {
          id: "ENABLED",
          label: "启用"
        },
        {
          id: "NOT_ENABLED",
          label: "停用"
        }
      ],
      isSystemCaseEnum: [
        {
          id: true,
          label: "是"
        },
        {
          id: false,
          label: "否"
        }
      ]
    };
  },
  watch: {
    dialogViewData() {
      if (this.dialogViewData) {
        this.viewFrom = JSON.parse(JSON.stringify(this.dialogViewData));
        this.dialogVisible = true;
      }
    }
  },
  methods: {
    // 确定添加
    addConfirm() {
      this.$refs.addFromRef.validate(valid => {
        if (valid) {
          this.addFrom.dictItems = JSON.parse(JSON.stringify(this.dicTableData));
          if (this.operType === "add") {
            Dict.addDict(this.addFrom).then(
              res => {
                this.addDictFlag = false;
                this.startSearch();
              },
              err => {
                this.$message({
                  message: err.message,
                  type: "error"
                });
              }
            );
          } else if (this.operType === "edit") {
            Dict.editDict(this.addFrom).then(
              res => {
                this.addDictFlag = false;
                this.startSearch();
              },
              err => {
                this.$message({
                  message: err.message,
                  type: "error"
                });
              }
            );
          }
        }
      });
    },
    viewDialogClosed() {
      this.viewDictFlag = false;
    },
    // 级联子表是否系统格式化
    caseCadeIsSystemFormate(row) {
      return this.caseCadeIsSystemTrans(row.systemDefault);
    },
    caseCadeIsSystemTrans(type) {
      for (let i = 0; i < this.isSystemCaseEnum.length; i++) {
        if (this.isSystemCaseEnum[i].id === type) {
          return this.isSystemCaseEnum[i].label;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view_form{
  ::v-deep .el-form-item {
    .el-form-item__label {
      line-height: 40px !important;
      text-align: right;
    }
    .el-form-item__content {
      line-height: 40px !important;
    }
  }
}
//  .view_form {
//   .el-form-item__label {
//     line-height: 40px !important;
//     text-align: right;
//   }
// }

.view--casecade-title {
  margin-bottom: 18px;
  font-size: 16px;
  font-weight: 600;
}

.el-table--striped
  .el-table__body
  tr.el-table__row--striped.el-table__row--striped.el-table__row--striped
  td {
  background-color: #d4d9e2;
}
// .view_span_tips{
//   display: inline-block;
//   line-height: 40px;
//   height:40px;
// }
</style>

